export default "__VITE_ASSET__D50FT2XB__"